import React, { useState, useRef, useEffect } from "react";
import dropdownIcon from "../../assets/dropdown_icon.png";
import { Link } from "react-router-dom";
import { useProfile } from "../../context/ProfileContext";

const DropdownMenu = ({ onOptionClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const { isDarkMode } = useProfile();

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (option) => {
    setIsOpen(false);
    onOptionClick(option);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonRef.current && buttonRef.current.contains(event.target)) {
        return;
      }
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative z-50">
      <button ref={buttonRef} onClick={handleToggle} className="p-2">
        <img src={dropdownIcon} alt="Menu" className="w-8 h-8 dark:invert" />
      </button>

      {isOpen && (
        <div
          ref={menuRef}
          className={`absolute top-12 right-0 w-56 rounded-2xl shadow-2xl ring-1 transition-all duration-300 ${
            isDarkMode
              ? "bg-brand-black ring-brand-gray border border-brand-gray"
              : "bg-white ring-black ring-opacity-5"
          }`}
        >
          <div className="py-2 px-1">
            <button
              className="block w-full text-left px-4 py-3 text-sm rounded-xl hover:bg-slate-100 dark:hover:bg-brand-gray/30 dark:text-brand-white transition-colors"
              onClick={() => handleOptionClick("editProfile")}
            >
              Edit Profile
            </button>

          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;